import { appConfig } from "src/config";

export enum ADDON_SKU {
  OTC_BIOMARKERS = "OTC_BIOMARKERS",
  OTC_METABOLIC_MEN = "OTC_METABOLIC_MEN",
  OTC_METABOLIC_WOMEN = "OTC_METABOLIC_WOMEN",
  PEPTIDE_SERMORELIN = "PEPTIDE_SERMORELIN",
  RX_NAD_PLUS = "RX_NAD_PLUS",
}

export const ADDON_SKU_TO_PRODUCT_NAME: Record<ADDON_SKU, string> = {
  [ADDON_SKU.OTC_BIOMARKERS]: "otc-biomarkers",
  [ADDON_SKU.OTC_METABOLIC_MEN]: "otc-metabolic-men-sub",
  [ADDON_SKU.OTC_METABOLIC_WOMEN]: "otc-metabolic-women-sub",
  [ADDON_SKU.PEPTIDE_SERMORELIN]: "peptide-sermorelin",
  [ADDON_SKU.RX_NAD_PLUS]: "rx-nad-plus",
};

export const PEPTIDE_SERMORELIN_PRODUCT_NAME =
  ADDON_SKU_TO_PRODUCT_NAME[ADDON_SKU.PEPTIDE_SERMORELIN];

export const RX_NAD_PLUS_PRODUCT_NAME =
  ADDON_SKU_TO_PRODUCT_NAME[ADDON_SKU.RX_NAD_PLUS];

export type AddonEligibilityInfo = {
  ineligibleStates: string[];
};

export const ADDON_ELIGIBILITY_INFO: Record<ADDON_SKU, AddonEligibilityInfo> = {
  [ADDON_SKU.OTC_BIOMARKERS]: {
    ineligibleStates: appConfig.OTC_BIOMARKERS_INELIGIBLE_US_STATES,
  },
  [ADDON_SKU.OTC_METABOLIC_MEN]: {
    ineligibleStates: appConfig.OTC_METABOLIC_INELIGIBLE_US_STATES,
  },
  [ADDON_SKU.OTC_METABOLIC_WOMEN]: {
    ineligibleStates: appConfig.OTC_METABOLIC_INELIGIBLE_US_STATES,
  },
  [ADDON_SKU.PEPTIDE_SERMORELIN]: {
    ineligibleStates: appConfig.PEPTIDE_SERMORELIN_INELIGIBLE_US_STATES,
  },
  [ADDON_SKU.RX_NAD_PLUS]: {
    ineligibleStates: appConfig.RX_NAD_PLUS_INELIGIBLE_US_STATES,
  },
};

export function isStateEligibleForAddon(
  sku: ADDON_SKU,
  state: string
): boolean {
  return !ADDON_ELIGIBILITY_INFO[sku].ineligibleStates.includes(state);
}
